export const TIMEOUT = 3 * 1000; // 3s
